<script setup>
defineProps({ type: { type: String, default: "info" } })
</script>
<template>
  <div :class="type==='success' ? 'alert-success' : type==='error' ? 'alert-error' : 'alert'">
    <slot />
  </div>
</template>
